const objectValues = object => {
  return Object.keys(object).map(key => object[key]);
};

module.exports = {
  objectValues
};
